import { AllActions } from "./rootReducer";

export type ReviewsState = {
  dispensary: {
    loaded: boolean;
    totalCount?: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
    reviews?: Array<any>;
  };
};

const initialState: ReviewsState = {
  dispensary: {
    loaded: false,
  },
};

export const REVIEWS_DISPENSARY_LOAD = "reviews/dispensary/load";

export type ReviewsDispensaryLoadAction = {
  type: typeof REVIEWS_DISPENSARY_LOAD;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  reviews: Array<any>;
  totalCount: number;
};

export type ReviewsActions = ReviewsDispensaryLoadAction;

const reviewsReducer = (
  state = initialState,
  action: AllActions
): ReviewsState => {
  switch (action.type) {
    case REVIEWS_DISPENSARY_LOAD:
      return {
        ...state,
        dispensary: {
          loaded: true,
          reviews: action.reviews,
          totalCount: action.totalCount,
        },
      };
    default:
      return state;
  }
};

export default reviewsReducer;
